// extracted by mini-css-extract-plugin
module.exports = {"modal__paper":"modal__paper-26U0n","modalHeader":"modalHeader-GrmtN","close":"close-38HFU","root":"root-3pv4a","body":"body-2On7a"};